export const filesService = {
  async generateFiles(payload) {
    return axios.post("/achgateway/files", payload);
  }
};
